import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import TimesheetCategoryDropdown from "pages/TimeSheetManage/Dropdowns/TimesheetCategoryDropdown";
import { map } from "lodash";

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
  // No dropdown, so no show state needed
  const [categoryValue, setCategoryValue] = useState([]);



  const handleClear = () => {
    setExtraFiltersState({ values: {} });
    setCategoryValue([]);
  };

  const handleSearch = () => {
    onFilter();
  };

  // No cancel button needed in flex form

  const handleCategoryChange = (selected) => {
    setCategoryValue(selected);
    const categoryIds = map(selected, "value");
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, category_id: categoryIds },
    }));
  };

  return (
    <div className="filters-flex">
      <Form>
        <Row className="align-items-end g-3">
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Name"
                className="input-field w-100"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Account ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Account ID"
                className="input-field w-100"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Account Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Account Number"
                className="input-field"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Client ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Client ID"
                className="input-field"
              />
            </Form.Group>
          </Col>
          <Col className="d-flex gap-2 mt-3 mt-md-0">
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn w-100 mb-3"
            >
              <img src="/assets/images/search-white.svg" alt="" className="me-2" /> Search
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Filter;
